/** UserCasePermissions relevant to the frontend */
export const OpenDeviceConsolePermission = "open_device_console";
export const ModifyDevicePermission = "modify_device";
export const RedeployDevicePermisson = "redeploy_device";
export const CreateOrDeleteDevicePermission = "create_or_delete_device";

export const AccessPackagesPermission = "access_packages";
export const UploadPackagesPermission = "upload_package";
export const DeconstePackagesPermission = "delete_package";

export const SetDeviceSlotProperties = "set_slot_properties";

export const CreateOrCancelJobRunPermission = "create_or_cancel_job_run";
export const CreateOrDeleteJobPermission = "create_or_delete_job";

export const CreateOrCancelTestRunPermission = "create_or_cancel_test_run";
export const CreateOrDeleteTestPermission = "create_or_delete_test_template";
export const ManageTestsAndJobsPermission = "manage_tests_and_jobs";

export const ModifyTagPermission = "modify_tag";

export const CreateOrDeleteOwnSlotReservationsPermission = "slotReserv__create_or_delete_own_slot_reservations";
export const ManageSlotReservationsPermission = "slotReserv__manage_slot_reservations";

export const UseSeleniumSessionPermission = "use_selenium_session";

export const CreateOrDeleteImagePermission = "create_or_delete_image";
export const RecordVideosPermission = "record_videos";

/** Admin Permissions */
export const ManageUserPropertiesPermission = "manage_user_properties";
export const ManageUsersPermission = "manage_users";
export const ManageRolesPermission = "manage_roles";
export const ManageProjectsPermission = "manage_projects";
export const ManageSlotsPermission = "manage_device_slots";

/** Project Admin Permissions */
export const ProjectAdmin = "manage_project";

/**
 * Org-wide permissions
 */
export const AccessMobileAccess = 'access_mobileaccess';
